var map = {
	"./PM_1.svg": "2641",
	"./PM_10.svg": "271c4",
	"./PM_2.svg": "b5a2",
	"./PM_3.svg": "c001",
	"./PM_4.svg": "80d7",
	"./PM_5.svg": "64af",
	"./PM_6.svg": "4b4f",
	"./PM_7.svg": "2f81",
	"./PM_8.svg": "c28f",
	"./PM_9.svg": "a0fb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "01d3";